/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Caption_Style_Roll_Up_2Inputs */

const en_input_caption_style_roll_up_2 = /** @type {(inputs: Input_Caption_Style_Roll_Up_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 2`)
};

const fr_input_caption_style_roll_up_2 = /** @type {(inputs: Input_Caption_Style_Roll_Up_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déroulant 2`)
};

const de_input_caption_style_roll_up_2 = /** @type {(inputs: Input_Caption_Style_Roll_Up_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 2`)
};

const it_input_caption_style_roll_up_2 = /** @type {(inputs: Input_Caption_Style_Roll_Up_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 2`)
};

const ru_input_caption_style_roll_up_2 = /** @type {(inputs: Input_Caption_Style_Roll_Up_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 2`)
};

const es_input_caption_style_roll_up_2 = /** @type {(inputs: Input_Caption_Style_Roll_Up_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 2`)
};

const zh_cn2_input_caption_style_roll_up_2 = /** @type {(inputs: Input_Caption_Style_Roll_Up_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 2`)
};

const ja_input_caption_style_roll_up_2 = /** @type {(inputs: Input_Caption_Style_Roll_Up_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロールアップ2`)
};

const hi_input_caption_style_roll_up_2 = /** @type {(inputs: Input_Caption_Style_Roll_Up_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रोल-अप 2`)
};

const pt_pt2_input_caption_style_roll_up_2 = /** @type {(inputs: Input_Caption_Style_Roll_Up_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enrole 2`)
};

/**
* | output |
* | --- |
* | "Roll-Up 2" |
*
* @param {Input_Caption_Style_Roll_Up_2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_caption_style_roll_up_2 = /** @type {((inputs?: Input_Caption_Style_Roll_Up_2Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Caption_Style_Roll_Up_2Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_caption_style_roll_up_2(inputs)
	if (locale === "de") return de_input_caption_style_roll_up_2(inputs)
	if (locale === "it") return it_input_caption_style_roll_up_2(inputs)
	if (locale === "ru") return ru_input_caption_style_roll_up_2(inputs)
	if (locale === "es") return es_input_caption_style_roll_up_2(inputs)
	if (locale === "zh-CN") return zh_cn2_input_caption_style_roll_up_2(inputs)
	if (locale === "ja") return ja_input_caption_style_roll_up_2(inputs)
	if (locale === "hi") return hi_input_caption_style_roll_up_2(inputs)
	if (locale === "pt-PT") return pt_pt2_input_caption_style_roll_up_2(inputs)
	return en_input_caption_style_roll_up_2(inputs)
});